import axios from "axios";

const callWebApi = async (cUrl, oData, callBack) => {
	const oResponse = await axios.post(
		cUrl, oData
	).then((response) => {
		//console.log("response", response);
		if (response.status !== 200) { throw new Error(`${response.status}: ${response.statusText}`); }
		return response.data;
	}).catch((ex) => {
		return { status: "fail", message: ex.message };
	});
	//console.log("oResponse", oResponse);
	const oResponse_JohnStyle = {
		bErrOn: oResponse.status !== "success",
		cMessage: oResponse.message,
		oData: oResponse.status === "success" ? oResponse.data : null
	};
	if (typeof callBack === "function") { callBack(oResponse_JohnStyle); }
	return oResponse_JohnStyle;
};
/*
 const callWebApi = async (cUrl, oData, callBack) => {
	const oResponse = await fetch(cUrl, {
		method: "POST", headers: { "Content-Type": "application/json" },
		body: JSON.stringify(oData)
	}).then((response) => {
		if (!response.ok) { throw new Error(`${response.status}: ${response.statusText}`); }
		return response.json();
	}).catch((ex) => {
		return { status: "fail", message: ex.message };
	});
	const oResponse_JohnStyle = {
		bErrOn: oResponse.status !== "success",
		cMessage: oResponse.message,
		oData: oResponse.status === "success" ? oResponse.data : null
	};
	if (typeof callBack === "function") { callBack(oResponse_JohnStyle); }
	return oResponse_JohnStyle;
};
 */
export default callWebApi;
